import trimStart from 'lodash/trimStart'

export function serverUrl(url) {
  return (module.hot ? 'https://zion-ticket.dev.loc/' : '/') + trimStart(url, '/')
}
